import http from './http'

export default {
    create(payload) {
        return http.post('ordenes', payload)
    }
}